<div>
  <error-dialog></error-dialog>
  <app-novelty-user></app-novelty-user>
  <router-outlet></router-outlet>
</div>
